export default "__VITE_ASSET__BZXuE8bK__"